import React from 'react';
import Button from '../common/Button';
import './loginStyle.css';

const MaxSessionsModal = ({ onAccept, eviewMode = false }) => {
  const modalClass = `login-modal ${eviewMode ? 'eview-mode' : ''}`;

  return (
    <div className={modalClass}>
      <p className="login-modal__title">Session Error</p>
      <p className="login-modal__text">
        Maximum login sessions exceeded.
      </p>
      <p className="login-modal__text login-modal__text--emphasis">
        Try again later.
      </p>
      <div className="login-modal__buttons">
        <Button onClick={onAccept} buttonText="OK" />
      </div>
    </div>
  );
};

export default MaxSessionsModal;